import { FC, useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { SkillsAllSkillsQuery } from '../../graphQLOperations/__generated__/SkillsAllSkillsQuery.graphql';
import { getAllSkills } from '../../graphQLOperations/Skills';
import { AncestriesRelevanceIds, SkillsTableFilterState, SkillTableItem } from './SkillsTable';
import { PageInfo } from '../../models/PageInfo';

interface Props {
  setSkillList: (skills: SkillTableItem[] | null) => void;
  filterState: SkillsTableFilterState;
  fetchingData: boolean;
  firstLoad: boolean;
  pageInfo: PageInfo | undefined;
  setFetchingData: (state: boolean) => void;
  setFirstLoad: (state: boolean) => void;
  setPageInfo: (state: PageInfo) => void;
  setTotalRecords: (state: number) => void;
}

export const QueryComponent: FC<Props> = ({
  setSkillList,
  fetchingData,
  filterState,
  firstLoad,
  pageInfo,
  setFetchingData,
  setFirstLoad,
  setPageInfo,
  setTotalRecords,
}) => {
  const isMovingNext = filterState.page! - filterState.prevPage === 1;
  const isMovingPrevious = filterState.page! - filterState.prevPage === -1;
  const isNotMoving = filterState.page! - filterState.prevPage === 0;

  const { searchSkills } = useLazyLoadQuery<SkillsAllSkillsQuery>(
    getAllSkills,
    {
      searchQuery: filterState.filters.searchQuery,
      ancestriesIds: [AncestriesRelevanceIds.ESSENTIAL, AncestriesRelevanceIds.HELPFUL],
      first: fetchingData && (isMovingNext || isNotMoving || !pageInfo?.hasPreviousPage) ? filterState.rows : null,
      last: fetchingData && isMovingPrevious && pageInfo?.hasPreviousPage ? filterState.rows : null,
      skip: !firstLoad && !fetchingData,
      after: fetchingData && isMovingNext && pageInfo?.hasNextPage ? pageInfo?.endCursor : undefined,
      before: fetchingData && isMovingPrevious && pageInfo?.hasPreviousPage ? pageInfo?.startCursor : undefined,
    },
    { fetchPolicy: 'network-only', fetchKey: JSON.stringify(filterState) },
  );
  useEffect(() => {
    if (searchSkills?.nodes) {
      setTotalRecords(searchSkills.totalCount ?? 0);
      setPageInfo(searchSkills.pageInfo);
      setSkillList(searchSkills.nodes.map(n => n) as SkillTableItem[]);
    }
    setFetchingData(false);
    setFirstLoad(false);
  }, [searchSkills]);

  return <div style={{ display: 'none' }}></div>;
};
